import { render } from "./ReportsStreamsWards.vue?vue&type=template&id=efc2e1c2&scoped=true"
import script from "./ReportsStreamsWards.vue?vue&type=script&lang=js"
export * from "./ReportsStreamsWards.vue?vue&type=script&lang=js"

import "./ReportsStreamsWards.vue?vue&type=style&index=0&id=efc2e1c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc2e1c2"]])

export default __exports__